<main class="bk-auth">
  <div class="bk-auth__col">
    <div class="bk-auth__brand">
      <span class="bk-auth__logo">
        <img
          class="bk-auth__logo-img bk-auth__logo-img--on-light"
          src="/images/BlackKonnectLogo_dark.png"
          alt="Black Konnect"
          width="720"
          height="380"
        />
        <img
          class="bk-auth__logo-img bk-auth__logo-img--on-dark"
          src="/images/BlackKonnectLogo_light.png"
          alt="Black Konnect"
          width="720"
          height="380"
        />
      </span>

      @if (showEnvironment) {
        <!-- The detail is in sr-only text too: a title tooltip is out of reach
             for keyboard and touch. -->
        <span class="bk-chip bk-auth__env" [attr.data-env]="env.kind" [title]="env.title">
          <span class="bk-sym" aria-hidden="true">{{ env.icon }}</span>
          <span class="bk-sr-only">Environment:</span>
          <span class="bk-auth__env-label">{{ env.label }}</span>
          <span class="bk-sr-only">. {{ env.title }}.</span>
        </span>
      }
    </div>

    <header class="bk-auth__head">
      @if (eyebrow) {
        <p class="bk-eyebrow">{{ eyebrow }}</p>
      }
      <h1 class="bk-heading bk-auth__title" tabindex="-1" #headingEl>{{ heading }}</h1>
      @if (sub) {
        <p class="bk-auth__sub">{{ sub }}</p>
      }
      <ng-content select="[authSub]"></ng-content>
    </header>

    <div class="bk-auth__body">
      <ng-content></ng-content>
    </div>

    <footer class="bk-auth__foot"><ng-content select="[authFoot]"></ng-content></footer>
  </div>
</main>
